module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Paragraph-520d0caba127a074979c5bf65b61c789.svg";